import { CaptureStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../config/types';
import { StatusTag } from '../StatusTag';

export const CaptureStatusTag: React.FC<{ status: CaptureStatus }> = ({ status }) => {
  const getStatusTagProps = (): React.ComponentProps<typeof StatusTag> => {
    switch (status) {
      case CaptureStatus.APPROVED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'ORDER_APPROVED',
          colorType: 'dark',
        };
      case CaptureStatus.PENDING:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'PENDING',
          colorType: 'dark',
        };
      case CaptureStatus.CONFIRMED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'CONFIRMED',
        };
      case CaptureStatus.REJECTED:
        return {
          type: StatusTagType.ERROR,
          labelTextId: 'REJECTED',
        };
      case CaptureStatus.READY_TO_PROCESS:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'READY_TO_PROCESS',
        };
    }
  };

  const statusTagProps = getStatusTagProps();
  return <StatusTag {...statusTagProps} />;
};
